import { createFileRoute } from '@tanstack/react-router';

import { IconHandoffPage } from '@/pages/icon-handoff';

export const Route = createFileRoute('/icon-handoff/')({
    component: IconHandoffPage,
});
